import { render, staticRenderFns } from "./VerifyAccountSecondStep.vue?vue&type=template&id=388e53e6&scoped=true&"
import script from "./VerifyAccountSecondStep.vue?vue&type=script&lang=js&"
export * from "./VerifyAccountSecondStep.vue?vue&type=script&lang=js&"
import style0 from "./VerifyAccountSecondStep.vue?vue&type=style&index=0&id=388e53e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388e53e6",
  null
  
)

export default component.exports